import { type FormEvent, useState } from "react";

export type AddPendingItemValues = {
  title: string;
  providerId: string | null;
  providerName: string | null;
};

type Props = {
  onClose: () => void;
  onAdd: (params: AddPendingItemValues) => void;
  initialTitle?: string;
  initialProviderId?: string | null;
  initialProviderName?: string | null;
};

export function useAddPendingItemModal(props: Props) {
  const [title, setTitle] = useState(props.initialTitle || "");
  const [providerId, setProviderId] = useState<string | null>(props.initialProviderId || null);
  const [providerName, setProviderName] = useState(props.initialProviderName || "");

  function resetForm() {
    setTitle(props.initialTitle || "");
    setProviderId(props.initialProviderId || null);
    setProviderName(props.initialProviderName || "");
  }

  function handleClose() {
    resetForm();
    props.onClose();
  }

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();

    if (!title.trim()) {
      return;
    }

    props.onAdd({ title: title.trim(), providerId, providerName: providerName || null });
    resetForm();
    props.onClose();
  }

  return {
    title,
    setTitle,
    providerId,
    setProviderId,
    providerName,
    setProviderName,
    isValid: title.trim().length > 0,
    handleClose,
    handleSubmit,
  };
}
